var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerifiedConnections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1232 -175)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.2307 11.3079C20.5856 11.3079 19.937 11.4531 19.3628 11.7331 19.3593 11.7331 19.3593 11.7367 19.3558 11.7367 17.853 12.4633 16.9208 13.9519 16.9208 15.6177L16.9208 15.6353C16.9244 15.6531 16.9244 15.6744 16.9244 15.692L16.9244 15.7275C16.9847 18.0454 18.9091 19.9239 21.2307 19.9239 23.6053 19.9239 25.5369 17.9923 25.5369 15.6177 25.5369 13.2395 23.6053 11.3079 21.2307 11.3079ZM23.4458 15.0825 21.3016 17.2268C21.1527 17.3756 20.9578 17.4465 20.7628 17.4465 20.5643 17.4465 20.3694 17.3756 20.2206 17.2268L19.0191 16.0217C18.7214 15.724 18.7214 15.242 19.0191 14.9407 19.3167 14.6429 19.7988 14.6429 20.0965 14.9407L20.7628 15.607 22.3649 14.0014C22.6625 13.7037 23.1481 13.7037 23.4458 14.0014 23.7435 14.3028 23.7435 14.7847 23.4458 15.0825Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0125 0 0 1 1232 175)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.365 7.75646C17.4844 7.75646 19.2069 6.03395 19.2069 3.91802 19.2105 1.79861 17.4844 0.0760995 15.365 0.0760995 13.249 0.0760995 11.5265 1.79861 11.5265 3.91454 11.5265 6.03395 13.2525 7.75646 15.365 7.75646Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0125 0 0 1 1232 175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3968 15.6177C15.3968 15.3872 15.4075 15.164 15.4393 14.9407 15.6095 13.3847 16.3963 11.9919 17.612 11.0349 17.9451 10.7727 18.3102 10.5422 18.7036 10.3545 18.8454 10.2871 18.9907 10.2233 19.1396 10.1666 18.0408 9.40461 16.7188 8.9863 15.372 8.9863 11.7179 8.9863 8.74421 11.96 8.74421 15.6141L8.74421 15.7027C8.74421 16.1209 9.08449 16.4647 9.50627 16.4647L15.4606 16.4647C15.4252 16.2272 15.4039 15.9862 15.4004 15.7417 15.3968 15.7062 15.3968 15.6637 15.3968 15.6177Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0125 0 0 1 1232 175)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerifiedConnections);
export default __webpack_public_path__ + "static/media/icon-verified-connections.2eb479638387f167a049f70d262b81f6.svg";
export { ForwardRef as ReactComponent };